import { memo } from "react";
import styles from "./NumberOfColumn.module.scss";
import cn from "classnames";
import { INumberOfColumnsProps } from "./NumberOfColumn.props";
import { useNumberOfColumnControl } from "./useNumberOfColumnControl";

function NumberOfColumn({
  children,
  className,
  ...props
}: INumberOfColumnsProps) {
  const control = useNumberOfColumnControl(props);
  return (
    <div
      className={cn(styles.wrapper, className, {
        [styles.left]: !!control.positionLeft,
        [styles.bottom]: !!control.positionBottom,
      })}
      data-left={control.positionLeft}
      data-bottom={control.positionBottom}
      onMouseDown={(e) => { if (e.ctrlKey) { e.stopPropagation(); e.preventDefault(); } }}
    >
      {children}
    </div>
  );
}

export default memo(NumberOfColumn);
